<template>
  <div class="aside-item">
    <div class="aside-item-title">{{ $t('Популярные магазины') }}</div>
    <div class="popular-shop-list">
      <a class="popular-shop-list-item" :href="shopUrl(shop.slug)" v-for="shop in popularShops" :key="shop.id">{{ shop.name }}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'shop-popular-aside',

  components: {
  },

  data() {
    return {};
  },

  computed: {
    ...mapState(['popularShops']),
  },

  methods: {
  }
};
</script>

<style scoped>
.popular-shop-list {
  margin-top: 25px;
}

.popular-shop-list-item {
  cursor: pointer;
  border: 1px solid #868993;
  border-radius: 27px;
  display: inline-block;
  margin-bottom: 8px;
  margin-right: 2px;
  padding: 4px 8px;
}

.popular-shop-list-item:hover {
  color: #3c91e6;
}

.popular-shop-list-item:active {
  color: #29629c;
}
</style>
